export default __webpack_public_path__ + "static/media/carbon_footprint.a430250a.jpg";